import React from 'react'
import AnsUser from '../ansuser/AnsUser'
import MenuDoctor from './navDoctor/MenuDoctor'
function CommentMedical() {
    return (
        <div className='global-page'>
            <MenuDoctor menuActive={'ans'} />
            <AnsUser roleUser={'Medical'} />
        </div>
    )
}

export default CommentMedical